module.exports = __webpack_public_path__ + "assets/img/9.cad7d7d9.png";